import { createContext } from "react"

export interface HoverState {
  /** Hovered X timestamp in milliseconds */
  x: number
  /** Hovered Y position as a proportion (0–1) of the drawing area height */
  yProportion: number
}

type HoverCallback = (state: HoverState | null) => void

export interface HoverSyncContextValue {
  subscribe: (cb: HoverCallback) => () => void
  publish: (state: HoverState | null) => void
}

const HoverSyncContext = createContext<HoverSyncContextValue | null>(null)

export default HoverSyncContext
